import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 9a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M9 9a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M5 9v11a2 2 0 1 0 4 0v-4.5","key":"svg-2"}]]

const IconBrandPicsart = createReactComponent('outline', 'brand-picsart', 'BrandPicsart', __iconNode);

export default IconBrandPicsart;